var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6364 12.5837V7.92577C15.6364 5.08182 13.6584 2.70145 11.0036 2.08091C11.0097 2.02803 11.0196 1.97624 11.0196 1.92172C11.0196 1.15553 10.3985 0.534424 9.63231 0.534424C8.86612 0.534424 8.24502 1.15553 8.24502 1.92172C8.24502 1.97624 8.25495 2.02803 8.26106 2.08091C5.60622 2.70145 3.62825 5.08182 3.62825 7.92577V12.5837L1.84542 15.3326C1.68748 15.5762 1.86227 15.8979 2.15257 15.8979H17.1121C17.4023 15.8979 17.5772 15.5762 17.4192 15.3326L15.6364 12.5837Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07948 1.06861L4.35761 0C1.75133 1.76101 0.195312 4.68762 0.195312 7.82887H1.48498C1.48498 5.11662 2.82878 2.58926 5.07948 1.06861Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8376 0L14.1157 1.06861C16.3664 2.58926 17.7102 5.11662 17.7102 7.82887H18.9999C18.9999 4.68762 17.4439 1.76101 14.8376 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63238 20C11.1527 20 12.3851 18.7676 12.3851 17.2473H6.87964C6.87964 18.7676 8.11209 20 9.63238 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderIcon);
export default __webpack_public_path__ + "static/media/reminder-icon.62e6f35563d9436c754165365f12a6f0.svg";
export { ForwardRef as ReactComponent };